'use strict';

module.exports = /*@ngInject*/ function () {
    var factory = {};
    var storage = new Map();
    factory.save = function(id, messageDataStructure){
        storage.set(id, messageDataStructure);
    };
    factory.get = function(id){
        return storage.get(id);
    };
    return factory;
};